import * as MD from '@material-ui/core';
import * as React from 'react';
import { connect } from 'react-redux';
import { Route, RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';
import { IApplicationState, IConnectedReduxProps } from '../../Store';
import { I18N } from '../../Store/I18n/Types';
import { IUserState } from '../../Store/User/Types';
import { isNullOrUndefined } from '../../Utils/Various';
import { AllResources } from './ResourcesManagementTabsContent/AllResources';
import { Resource } from './ResourcesManagementTabsContent/Resource';

export interface IRouterMatchParams {
	groupName: string;
	type: string;
}

interface IPropsFromState {
	i18n: I18N;
	router: RouteComponentProps<IRouterMatchParams>;
	user: IUserState;
}

interface IPropsFromDispatch {}

type AllProps = IPropsFromState &
	IPropsFromDispatch &
	RouteComponentProps<{}> &
	IConnectedReduxProps;

export class ResourcesManagementContentComponent extends React.Component<AllProps> {
	public constructor(props: AllProps) {
		super(props);
	}

	public render(): React.ReactNode {
		switch (this.props.router.match.params.type) {
			case 'resources':
				return (
					<React.Fragment>{this.renderResources()}</React.Fragment>
				);
			default:
				return (
					<React.Fragment>{this.renderResources()}</React.Fragment>
				);
		}
	}

	private renderResources(): React.ReactNode {
		let mode = 0;
		if (isNullOrUndefined(this.props.router.match.params.type)) {
			mode = 0;
		} else {
			if (!isNaN(parseInt(this.props.router.match.params.type, 10))) {
				mode = 1;
			} else {
				mode = 0;
			}
		}
		return (
			<React.Fragment>
				<MD.Tabs
					onChange={this.handleTabs.bind(this)}
					value={mode}
					indicatorColor="primary"
					textColor="primary"
				>
					<MD.Tab label={this.props.i18n._('Global view')} />
					{mode === 1 ? (
						<MD.Tab
							label={this.props.i18n._(
								'view of resource #' +
									parseInt(
										this.props.router.match.params.type,
										10
									)
							)}
						/>
					) : (
						''
					)}
				</MD.Tabs>
				<this.TabPanel value={mode} index={0}>
					<Route component={AllResources} />
				</this.TabPanel>
				<this.TabPanel value={mode} index={1}>
					<Route component={Resource} />
				</this.TabPanel>
			</React.Fragment>
		);
	}

	private TabPanel(props: any): JSX.Element {
		const { children, value, index } = props;
		return <div>{value === index && <div>{children}</div>}</div>;
	}

	private handleTabs(e: React.ChangeEvent<{}>, val: number) {
		switch (val.toString(10)) {
			case '0':
				this.props.router.history.push(`/ressources/ressources`);
				break;
			default:
				this.props.router.history.push(`/ressources/ressources`);
		}
	}
}

const mapStateToProps = (
	{ i18n, user }: IApplicationState,
	ownProps: RouteComponentProps<IRouterMatchParams>
) => ({
	i18n: i18n.i18n,
	router: ownProps,
	user,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({});

export const ResourcesManagementContent = connect(
	mapStateToProps,
	mapDispatchToProps
)(ResourcesManagementContentComponent);
